import { useCreate, useDelete, useGetAll, useGetOne, useUpdate } from "./crudService";

const endpoint:string = 'zones';

export function useGetAllZonings(params:{page:number}, queryParams:any = {}) {
    return useGetAll({queryKey: [endpoint], ...queryParams}, params);
}

export function useGetZoning(id: number, params:any = {}) {
    return useGetOne({queryKey: [endpoint, id], ...params});
}

export function useCreateZoning() {
    return useCreate({queryKey: [endpoint]});
}

export function useUpdateZoning({id}) {
    return useUpdate({queryKey: [endpoint, id]});
}

export function useDeleteZoning({id}) {
    return useDelete({queryKey: [endpoint, id]});
}
